import { render, staticRenderFns } from "./PasswordResetHeader.vue?vue&type=template&id=37559906"
import script from "./PasswordResetHeader.vue?vue&type=script&lang=js"
export * from "./PasswordResetHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37559906')) {
      api.createRecord('37559906', component.options)
    } else {
      api.reload('37559906', component.options)
    }
    module.hot.accept("./PasswordResetHeader.vue?vue&type=template&id=37559906", function () {
      api.rerender('37559906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/partials/PasswordResetHeader.vue"
export default component.exports